import httpClient from '../httpClient';

const change = () => {
  return httpClient.post(`user/subscription/change`);
};

const getDetails = () => {
  return httpClient.get('user/subscription/details');
};

const renew = () => {
  return httpClient.post(`user/subscription/renew`);
};

const subscribe = values => {
  return httpClient.post(`user/subscription/subscribe`, values);
};

const unsubscribe = () => {
  return httpClient.post(`user/subscription/unsubscribe`);
};

export default {
  change,
  getDetails,
  renew,
  subscribe,
  unsubscribe,
};
